module.exports = __webpack_public_path__ + "img/mistakesText3.862fb5c5.png";